import { isString, chain, values } from 'lodash'
import moment from 'moment'
import { date2str, str2date } from '../lib/Tools'

const deletePreviousHours = (dayCursor, times) => {
  if (dayCursor.isSame(moment(), 'day')) {
    return times.filter(hour => moment().format('HH:mm') < hour)
  }
  else return times
}

const _findSchedule = (schedulesArray, sdate) => (
  schedulesArray.find(sch => (sch.startDate <= sdate && sdate <= sch.endDate))
)

const _getWeekdayIndex = (sdate) => str2date(sdate).getDay()

const _findTimes = (definition, sdate) => (
  (!definition && [])
  || (definition.date && definition.times)
  || definition.weekDays[_getWeekdayIndex(sdate)].times
)
const _findAllDayTimes = (definition, sdate) => {
  if (definition) {
    if (definition.date) return definition.allDayTimes
    else return definition.weekDays[_getWeekdayIndex(sdate)].allDayTimes
  }
  else return ""
}
const _findOpen = (definition, definitionType, sdate) => {
  if (definitionType == "exception") return definition.isOpen
  else return definition.weekDays[_getWeekdayIndex(sdate)].isOpen
}


export const checkDate = (timetable, date) => {
  const sdate = isString(date) ? date : date2str(date)
  const schedulesArray = values(timetable.schedules)

  let definitionType = "undefined"
  let definition = null

  if (timetable.exceptions[sdate]) {
    definitionType = "exception"
    definition = timetable.exceptions[sdate]
  }
  else {
    const sch = _findSchedule(schedulesArray, sdate)
    if (sch) {
      definitionType = "schedule"
      definition = sch
    }
  }
  const times = _findTimes(definition, sdate)
  const allDayTimes = _findAllDayTimes(definition, sdate)
  const open = definition && _findOpen(definition, definitionType, sdate)
  const note = (definition && definition.note) || ""

  return { open, definitionType, definition, times, allDayTimes, note }
}

export const getTimeObject = (timetable, date) => {
  const formatedDay = moment(date).format('YYYY/MM/DD')
  const exception = timetable.exceptions[formatedDay]
  if (exception) return exception

  const schedule = chain(timetable.schedules)
    .values()
    .find(sch => (
      sch.startDate <= formatedDay
                && formatedDay <= sch.endDate
    ))
    .value()
  if (schedule) return schedule
  else return null
}

export function getHoursData(timetable, dayCursor) {
  const formatedDay = dayCursor.format('YYYY/MM/DD')
  const exception = timetable.exceptions[formatedDay]
  if (exception && exception.isOpen) return {
    label: dayCursor.locale("zh_cn").format("LL"),
    times: deletePreviousHours(dayCursor, exception.times),
    allDayTimes: exception.allDayTimes
  }

  const schedule = chain(timetable.schedules)
    .values()
    .find(sch => (
      sch.startDate <= formatedDay
      && formatedDay <= sch.endDate
    ))
    .value()
  if (schedule && schedule.weekDays[dayCursor.day()].isOpen) return {
    label: dayCursor.locale("zh_cn").format("LL"),
    times: deletePreviousHours(dayCursor, schedule.weekDays[dayCursor.day()].times),
    allDayTimes: schedule.weekDays[dayCursor.day()].allDayTimes
  }
  else return null
}



// WEBPACK FOOTER //
// ./src/lib/timetable.js